// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A_nB8","footer":"styles_footer__3tRKv"};